import React, { useEffect, useRef, useState } from 'react';
import disableParking from './images/DisableParking.png';
import FallDetect from './images/FallDetect.png';
import parking from './images/Parking.png';
import normalpump from './images/Pump.png';
import pumpoff from './images/PumpOff.png';
import rubbishbin from './images/RubbishBin.png';
import rubbishbin10 from './images/RubbishBin_10.png';
import rubbishbin20 from './images/RubbishBin_20.png';
import rubbishbin30 from './images/RubbishBin_30.png';
import rubbishbin40 from './images/RubbishBin_40.png';
import rubbishbin50 from './images/RubbishBin_50.png';
import rubbishbin60 from './images/RubbishBin_60.png';
import rubbishbin70 from './images/RubbishBin_70.png';
import rubbishbin80 from './images/RubbishBin_80.png';
import rubbishbin90 from './images/RubbishBin_90.png';
import tanknormal from './images/WaterTankNormal.png';
import groundFloor from './images/YTMapNew.png';
import Cctv from './images/cctv.png';
import dooropen464 from './images/dooropen464_brown.png';
import icon from './images/icons8-place-marker-48.png';
import iconhover from './images/icons8-place-marker.gif';
import ppeople from './images/ppeople.png';
import waterdrop from './images/waterdrop.png';
import Rodent from './images/Rodent.png';
import Irrigation from './images/irrigation.png';
import IrrigationOff from './images/irrigationOff.png';
import Trolley from './images/Trolley.png';
import CarCharger from './images/klipartz.com.png';

import chime from './chime.mp3';
import redTick from './images/RedTick.png';
import click from './shortclick.mp3';
import waterdropsound from './water-droplet.mp3';
import fallsiren from './Ambulance30s.mp3';
import cameraAlarm from './CameraAlarm.mp3';
import thunderWithRain from './ThunerWithRainMix.mp3'

import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Map.css';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CarIcon from '@mui/icons-material/DirectionsCar';
import FactoryIcon from '@mui/icons-material/Factory';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import DoorIcon from '@mui/icons-material/SensorDoor';
import OccupiedIcon from '@mui/icons-material/SensorOccupied';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import PestControlRodentIcon from '@mui/icons-material/PestControlRodent';
import GrassIcon from '@mui/icons-material/Grass';
import CropFreeIcon from '@mui/icons-material/CropFree';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WcIcon from '@mui/icons-material/Wc';

const FloorWidth = 555;
const LargeCellText = "30px";

// A custom component that displays an image
function FloorplanImage(props) {
    return (
        <div className="estate-image" align-items="center">
            < img src={props.src} alt={props.alt} width={FloorWidth} />
        </div>
    );
}

function RubbishBinIcon({ level }) {
    const binStyle = {
        background: 'rubbishbin no-repeat center center',
        width: '50px',
        height: '50px',
        position: 'relative'
    };

    const rubbishStyle = {
        background: 'grey',
        width: '100%',
        height: `${level}%`,
        position: 'absolute',
        bottom: '0'
    };

    return (
        <div style={binStyle}>
            <div style={rubbishStyle}></div>
        </div>
    );
}

export default function Map({ location, selectedFloor }) {
    //const [tindex, setTindex] = useState(1);
    const waterleakagetype = 4;

    const tindex = useRef(1);

    const carStatus = useRef(0);
    const disCarStatus = useRef(0);
    const doorStatus = useRef(0);
    const leakStatus = useRef(0);
    const corridorStatus = useRef(0);
    const fallStatus = useRef([]);
    const cameraStatus = useRef(0);
    const ratStatus = useRef(0);
    //const fallStatus = useRef(0);
    const irrStatus = useRef(0);

    const binStatus = useRef(0);
    const devLogic = useRef();
    const diffArray = useRef();
    const notifArray = useRef([]);
    //const tArray = useRef([]);

    const tArray = useRef([]);
    //const recordArray = useRef([]);
    //const recordArray = useRef([]);
    const notif = useRef([]); 

    const [recordArray, setRecordArray] = useState([]);
    //const [tempArray, setTempArray] = useState([]);
    const [content, setContent] = useState('Initial content');
    //const [notifArray, setNotifArray] = useState([]);
    //const [playTone] = useSound(tone); // Initialize the useSound hook

    // create loading and retry states
    const [retry, setRetry] = useState(false);

    // state variable to store the data from the web API
    const [pins_g, setPins_g] = useState([]);
    const [dev, setDev] = useState([]);
    const [displaydev, setDisplsyDev] = useState([]);

    // A state variable to store the websocket object
    const [socket, setSocket] = useState(null);

    // Using state variables to store the background color and the class name
    const [bgColor, setBgColor] = useState("lightblue");

    const [hoveredCell, setHoveredCell] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [selectedType, setSelectedType] = useState(1);

    //let tArray;

    //const [audio] = useState(new Audio("./chime.wav"));
    //var audio = new Audio("./chime.wav")

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    // Create a connection to the hub
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    // Handle button click
    function handleClick(e) {
        //setTindex(e);
        playClickSound();
        setSelectedType(e);
        tindex.current = e;
        let filteredDev = dev.filter(d => d.data_type === e);
        setDisplsyDev(filteredDev);
    };

    const PinIcon = ({ id, x, y, src, hoverSrc, scale }) => {
        // Use a state variable to keep track of whether the mouse is over the icon or not.
        //const [isHovered, setIsHovered] = useState(false);

        // Define a function that handles the mouse enter event and sets the state to true.
        const handleMouseEnter = () => {
            //setIsHovered(true);
            switch (dev[id-1].data_type) {
                case 1:
                    handleClick(1);
                    handleCellHilight(id - 1);
                    break;
                case 2:
                    handleClick(2);
                    handleCellHilight(id-12);
                    break;
                case 3:
                    handleClick(3);
                    handleCellHilight(id-28);
                    break;
                case 4:
                    handleClick(4);
                    handleCellHilight(id-34);
                    break;
                default:
            }
            setIsHovered(id);

        };

        // Define a function that handles the mouse leave event and sets the state to false.
        const handleMouseLeave = () => {
            setIsHovered(false);
            handleCellNormal();

        };

        // Return a JSX element that renders an image tag with the appropriate attributes and styles.
        return (
            <img
                //src={isHovered === id ? hoverSrc : src} // Use the hoverSrc if the mouse is over the icon, otherwise use the src.
                src={src} // Use the hoverSrc if the mouse is over the icon, otherwise use the src.
                alt="pin icon" // Provide an alternative text for accessibility.
                style={{
                    position: "absolute", // Use absolute positioning to place the icon on top of the background image.
                    //left: isHovered === id ? (x - 8) : x + "px", // Use the x prop as the left offset in pixels.
                    //top: isHovered === id ? (y - 9) : y + "px", // Use the y prop as the top offset in pixels.
                    left: isHovered === id ? (x - 11) : x + "px", // Use the x prop as the left offset in pixels.
                    top: isHovered === id ? (y - 18) : y + "px", // Use the y prop as the top offset in pixels.
                    //width: "25px", // Set a fixed width for the icon in pixels. You can change this as you like.
                    width: isHovered === id ? "48px" : "25px", // Set a fixed width for the icon in pixels. You can change this as you like.
                    //height: "25px", // Set a fixed height for the icon in pixels. You can change this as you like.
                    height: isHovered === id ? "48px" : "25px", // Set a fixed height for the icon in pixels. You can change this as you like.
                    transition: "transform 0.3s ease-in-out", // Use a transition effect to animate the icon when it changes size on hover.
                }}
                onMouseEnter={handleMouseEnter} // Attach the mouse enter handler to the image tag.
                onMouseLeave={handleMouseLeave} // Attach the mouse leave handler to the image tag.
                fluid
            />
        );
    }




    const ImageWithPins = ({ pins }) => {
        return (
            <div>
                {pins.map((pin) => (
                    // For each pin object in the pins array, render a PinIcon component with its properties as props.
                    <PinIcon
                        key={pin.x + "," + pin.y} // Use a unique key for each PinIcon component based on its coordinates.
                        id={pin.id}
                        x={pin.x} // Pass the x coordinate as a prop.
                        y={pin.y} // Pass the y coordinate as a prop.
                        src={icon}
                        hoverSrc={iconhover}
                    />
                ))}
            </div>
        );
    }

    useEffect(() => {
        // Create an instance of HttpClient
        const httpClient1 = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const httpClient2 = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const httpClient3 = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData1 = async () => {
        // Call the web API endpoint with GET method
            await httpClient1.get('/api/estatedevicelocations')
                .then((response) => {
                    const coordinates = response.data.map((item) => ({
                        id: item.deviceLocationId,
                        x: item.positionX * FloorWidth / 660,
                        //x: (item.positionX * 600 / 856) -20,
                        y: item.positionY * FloorWidth / 660,
                        //y: (item.positionY * 600 / 856) - 30,
                        level: item.deviceDescription,
                    }));
 
                    // Filter pins with id smaller than 22 and greater than 1
                    //const filteredPins = coordinates.filter(pin => pin.id > 1 && pin.id < 22);
                    let filteredPin_2 = coordinates.filter(pin => (pin.id > 0 && pin.id < 40) || (pin.id > 40 && pin.id < 47));
                    let scale = 660 / 929;
                    let scaledPin_2 = filteredPin_2.map(fpin => {
                        //return { ...item, x: item.x * scale + 10, y: item.y * scale - 10 };
                        return { ...fpin, id: fpin.id, x: fpin.x * scale + 10, y: fpin.y * scale - 10 };
                    });
                    // Set the pins state with the coordinates
                    setPins_g(scaledPin_2);

                })
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };
        // Call the web API endpoint with GET method
        const getData2 = async () => {

            await httpClient2.get('/api/devices')
                .then((response) => {
                    const deviceDetails = response.data.map((item) => ({
                        id: item.deviceId,
                        deviceName: item.deviceName,
                        deviceEUI: item.deviceEUI,
                        model: item.model,
                        serialNo : item.serialNo,
                        label: item.label,
                        status: item.status,
                        logic: item.type,
                        data_type: item.dataType,
                        alive: item.alive
                    }));

                    let dev_logic = deviceDetails.map((item) => ({
                        logic: item.logic,
                        model: item.model,
                        serialNo: item.serialNo,
                        status: item.status,
                        data_type: item.data_type,
                        alive: item.alive
                    }));

                    devLogic.current = dev_logic;
                    // Set the pins state with the coordinates
                    setDev(deviceDetails);
                    //console.log(deviceDetails); 

                    let filteredDev = deviceDetails.filter(d => d.data_type === 1);

                    let tempCarDev = filteredDev.filter(item => item.logic === 1);

                    disCarStatus.current = tempCarDev.filter(item => (item.id > 0 && item.id < 4)).length;
                    carStatus.current = tempCarDev.filter(item => ((item.id > 3) && (item.id < 12)) ).length;

                    console.log(carStatus.current); 


                    filteredDev = deviceDetails.filter(d => d.data_type === 2);

                    doorStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(doorStatus.current); 

                    filteredDev = deviceDetails.filter(d => d.data_type === 3);

                    corridorStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(corridorStatus.current); 

                    filteredDev = deviceDetails.filter(d => d.data_type === 4);

                    leakStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(leakStatus.current);

                    filteredDev = deviceDetails.filter(d => d.data_type === 7);

                    cameraStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(cameraStatus.current);

                    filteredDev = deviceDetails.filter(d => d.data_type === 8);

                    //fallStatus.current = filteredDev.filter(item => item.logic === 1);
                    fallStatus.current = filteredDev[0];
                    console.log(fallStatus.current);
                    if (fallStatus.current.logic === 0) {
                        setFallPlaying(false);
                    }

                    filteredDev = deviceDetails.filter(d => d.data_type === 9);
                    ratStatus.current = Math.round((filteredDev.reduce((accumulator, currentObject) => {
                        return accumulator + currentObject.logic;
                    }, 0))/10);

                    filteredDev = deviceDetails.filter(d => d.data_type === 10);
                    irrStatus.current = filteredDev.filter(item => item.serialNo === "ON").length;
                    console.log(irrStatus.current);

                    filteredDev = deviceDetails.filter(d => d.data_type === tindex.current);
                    setDisplsyDev(filteredDev);

                    console.log("Displadev");
                    console.log(filteredDev); 
                })
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };



        const getData3 = async () => {
            var count;

            await httpClient3.get('/api/yantinpastrecord/count')
                .then((response) => {
                    count = response;
                    console.log(count);
                    }
                 )
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });


            var connectionPath = '/api/yantinpastrecord/';
            //var tArray;
            await httpClient3.get(connectionPath)
                .then((response) => {

                    let mArray = response.data.map((item) => ({
                        Id: item.item,
                        Label: item.label,
                        Status: item.status,
                        DataType: item.dataType,
                        Timestamp: item.timestamp,
                        Acknowledge: item.acknowledge,
                        Name: item.name
                    }));
;
                    console.log(mArray);
                    tArray.current = mArray
                    console.log(tArray.current);

                }


                )
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });

 
        };      

        getData1();
        getData2();    
        getData3();  
         
    }, [retry]);

    // Create a ref for the dialog element
    const dialogRef = useRef();

    // Use useEffect hook to show the dialog when the component mounts
    //React.useEffect(() => {
    //    dialogRef.current.showModal();
    //}, []);

    // Start the connection and handle any errors
    useEffect(() => {
        let notif = [];

        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const compareArrays = (arr1, arr2) => {
            let diff = []; // an empty array to store the locations of different elements
            let element = [];
            arr1.map((item, index) => { // iterate over the first array
                if ((item.logic !== arr2[index].logic) && ( item.logic===1 )){ // compare the element with the second array element at the same index
                    element = { index: index, logic: item.logic, status: item.status };
                    diff.push(element); // if they are different, push the index to the diff array
                }
            });
            return diff; // return the diff array
        };

        const notification = (latest, ref) => {
            const audio = new Audio(chime);
            
            //let notif = [];
            let element = [];
            let new_alert = 0;
            let water_alert = 0;
            let fall_alert = 0;
            let camera_alert = 0;
            latest.map((item, index) => { // iterate over the first array                    
                if (item.logic !== ref[index].logic) { // compare the element with the second array element at the same index
                    element = { index: index, logic: item.logic, status: item.status, data_type: item.data_type };
                    
                    if (item.data_type === waterleakagetype) {  // John
                        notif.push(element); // if they are different, push the index to the diff array
                        water_alert = 1;
                    } else if (item.data_type === 7) {
                        camera_alert = 1;
                        notif.push(element);
                    } else if (item.data_type === 8) {
                        fall_alert = 1;
                    } else {
                        notif.push(element); // if they are different, push the index to the diff array
                        new_alert = 1;
                    }
                }
            });
            if (new_alert) audio.play();
            if (water_alert) setWaterPlaying(true);
            if (camera_alert) setCameraAlarmPlaying(true);
            if (fall_alert) setFallPlaying(true);
            return notif; // return the diff array
        };

        const copy_dev = (from_dev, to_dev) => {
            from_dev.map((item, index) => { // iterate over the first array                    
                if (item) {
                    to_dev[index].logic = item.logic;
                }
            });
        };

        // Call the web API endpoint with GET method
        const getData = async () => {

            await httpClient.get('/api/devices')
                .then((response) => {
                    const deviceDetails = response.data.map((item) => ({
                        id: item.deviceId,
                        deviceName: item.deviceName,
                        deviceEUI: item.deviceEUI,
                        model: item.model,
                        serialNo: item.serialNo,
                        label: item.label,
                        status: item.status,
                        logic: item.type,
                        data_type: item.dataType,
                        alive: item.alive
                    }));

                    setDev(deviceDetails);

                    let dev_logic = deviceDetails.map((item) => ({
                        logic: item.logic,
                        model: item.model,
                        serialNo: item.serialNo,
                        status: item.status,
                        data_type: item.data_type,
                        alive: item.alive
                    }));
                    console.log("Device logic#1:");
                    console.log(dev_logic);


                    console.log("Device logic#2:");
                    console.log(devLogic.current);

                    diffArray.current = compareArrays(dev_logic, devLogic.current);
                    console.log("Diff logic:");
                    console.log(diffArray.current);

                    console.log("Storage logic:");
                    if (diffArray.current.length) { 
                        notifArray.current = notification(dev_logic, devLogic.current);
                        console.log(notifArray.current);
                    }

                    devLogic.current = dev_logic;

                    let filteredDev = deviceDetails.filter(d => d.data_type === 1);

                    let tempCarDev = filteredDev.filter(item => item.logic === 1);

                    disCarStatus.current = tempCarDev.filter(item => (item.id > 0 && item.id < 4)).length;
                    carStatus.current = tempCarDev.filter(item => (item.id > 3 && item.id < 12)).length;

                    console.log(carStatus.current); 


                    filteredDev = deviceDetails.filter(d => d.data_type === 2);

                    doorStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(doorStatus.current); 


                    filteredDev = deviceDetails.filter(d => d.data_type === 3);

                    corridorStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(corridorStatus.current); 

                    filteredDev = deviceDetails.filter(d => d.data_type === 4);

                    leakStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(leakStatus.current); 

                    filteredDev = deviceDetails.filter(d => d.data_type === 7);

                    cameraStatus.current = filteredDev.filter(item => item.logic === 1).length;
                    console.log(cameraStatus.current); 

                    filteredDev = deviceDetails.filter(d => d.data_type === 8);

                    //fallStatus.current = filteredDev.filter(item => item.logic === 1);
                    fallStatus.current = filteredDev[0];
                    console.log(fallStatus.current);
                    if (fallStatus.current.logic === 0) {
                        setFallPlaying(false);
                    }

                    filteredDev = deviceDetails.filter(d => d.data_type === 9);
                    ratStatus.current = Math.round((filteredDev.reduce((accumulator, currentObject) => {
                        return accumulator + currentObject.logic;
                    }, 0)) / 10);

                    filteredDev = deviceDetails.filter(d => d.data_type === 10);
                    irrStatus.current = filteredDev.filter(item => item.serialNo === "ON").length;
                    console.log(irrStatus.current);

                    filteredDev = deviceDetails.filter(d => d.data_type === tindex.current);
                    setDisplsyDev(filteredDev);
                    console.log("Displadev"); 
                    console.log(filteredDev); 
                })
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });

            var connectionPath = '/api/yantinpastrecord/';
            //var tArray;
            await httpClient.get(connectionPath)
                .then((response) => {

                    let mArray = response.data.map((item) => ({
                        Id:  item.item,
                        Label: item.label,
                        Status: item.status,
                        DataType: item.dataType,
                        Timestamp: item.timestamp,
                        Acknowledge: item.acknowledge,
                        Name: item.name
                    }));
                    console.log(mArray);
                    tArray.current = mArray
                    console.log(tArray.current);

                }


                )
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });

        };

        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        // Register a handler for receiving device data from the hub
        connection.on("ReceiveDeviceData", () => {
            // Update the state with the new device data
            console.log("Updating....")
            getData();
        });
    }, []);


    const [wateraudio] = useState(new Audio(thunderWithRain));
    const [waterPlaying, setWaterPlaying] = useState(false);

    //const toggle = () => setPlaying(!playing);

    useEffect(() => {
        waterPlaying ? wateraudio.play() : wateraudio.pause();
    }, [waterPlaying]);

    useEffect(() => {
        wateraudio.loop = true;
        return () => {
            wateraudio.pause();
            wateraudio.currentTime = 0;
        };
    }, []);

    const [fallaudio] = useState(new Audio(fallsiren));
    const [fallPlaying, setFallPlaying] = useState(false);

    useEffect(() => {
        fallPlaying ? fallaudio.play() : fallaudio.pause();
    }, [fallPlaying]);

    useEffect(() => {
        fallaudio.loop = true;
        return () => {
            fallaudio.pause();
            fallaudio.currentTime = 0;
        };
    }, []);

    //=======
    const [cameraAlarmaudio] = useState(new Audio(cameraAlarm));
    const [cameraAlarmPlaying, setCameraAlarmPlaying] = useState(false);

    useEffect(() => {
        cameraAlarmPlaying ? cameraAlarmaudio.play() : cameraAlarmaudio.pause();
    }, [cameraAlarmPlaying]);

    useEffect(() => {
        cameraAlarmaudio.loop = true;
        return () => {
            cameraAlarmaudio.pause();
            cameraAlarmaudio.currentTime = 0;
        };
    }, []);



    const handleCellHilight = (index) => {
        setHoveredCell(index );
    };

    const handleCellNormal = () => {
        setHoveredCell(null);
    };

    const handleCellEnter = (index) => {
        setHoveredCell(index);
        playClickSound();
        switch (selectedType) {
            case 1:
                setIsHovered(index + 1);
                break;

            case 2:
                setIsHovered(index + 12);
                break;

            case 3:
                setIsHovered(index + 28);
                break;

            case 4:
                setIsHovered(index + 34);
                break;

            case 6:
                setIsHovered(index + 41);
                break;

            case 9:
                setIsHovered(index + 49);
                break;

            default:

        }
    };

    const handleCellLeave = () => {
        setHoveredCell(null);
        setIsHovered(false);
    };

    const updateContent = () => {
        // Update the state to some new content, which will trigger a re-render
        setContent('Updated content');
    };

    const sendMessage = async () => {
        try {
            await connection.invoke("ReceiveDeviceData");
        } catch (err) {
            console.error(err);
        }
    };

    const handleDelete = (prop) => {


        fetch(`https://yantindash.ddns.net/api/yantinpastrecord/${prop.Id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    // Include other headers as needed
                },
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Item deleted:', data);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });

        if (prop.DataType === waterleakagetype) setWaterPlaying(false);
        if (prop.DataType === 7) setCameraAlarmPlaying(false);


        //notifArray.current.splice(prop, 1);
        console.log("Deleting....");
        console.log(prop.Id);

        playClickSound();

        sendMessage();
        updateContent();
    };

    function BinIcon(props) {
        let level = parseInt(props.x, 10);
        if (level < 10) {
            return (
                <img src={rubbishbin} alt="rubbishbin" width="60px" />
            );
        } else if (level < 20) {
            return (
                <img src={rubbishbin10} alt="rubbishbin10" width="60px" />
            );
        } else if (level < 30) {
            return (
                <img src={rubbishbin20} alt="rubbishbin20" width="60px" />
            );
        } else if (level < 40) {
            return (
                <img src={rubbishbin30} alt="rubbishbin30" width="60px" />
            );
        } else if (level < 50) {
            return (
                <img src={rubbishbin40} alt="rubbishbin40" width="60px" />
            );
        } else if (level < 60) {
            return (
                <img src={rubbishbin50} alt="rubbishbin50" width="60px" />
            );
        } else if (level < 70) {
            return (
                <img src={rubbishbin60} alt="rubbishbin60" width="60px" />
            );
        } else if (level < 80) {
            return (
                <img src={rubbishbin70} alt="rubbishbin70" width="60px" />
            );
        } else if (level < 90) {
            return (
                <img src={rubbishbin80} alt="rubbishbin80" width="60px" />
            );
        } else {
            return (
                <img src={rubbishbin90} alt="rubbishbin90" width="60px" />
            );
        }
    };

    function cell_color(alive) {
        let color;
        switch (alive) {
            case null:
                color = "#111111";
                break;
            case 0:
                color = "#111111";
                break;
            case 1:
                color = "#520000";
                break;
            case 2:
                color = "#525252";
                break;
            default:
                color = "#525252";
        }
        return color;
    }

    function DList() {
        if (selectedType === 6) {
            return (
                <div>
                    <tr className="row">
                        {displaydev.map((dev_item, index) => (
                            <td key={index} className="bincellstyle" style={{
                                fontSize: "16px", overflow: "hidden", color: hoveredCell === index ? "#f7f4ef" : "#f7f4ef", backgroundColor: hoveredCell === index ? "#0009df" : cell_color(dev_item.alive)
                            }} onMouseEnter={() => handleCellEnter(index)} onMouseLeave={handleCellLeave}>

                                <table>
                                    <td>
                                        {dev_item.label}:{dev_item.deviceName}
                                    </td>
                                    <td>
                                        <br />
                                        <BinIcon x={dev_item.status} />
                                    </td>
                                </table>

                            </td>


                        ))}
                    </tr>
                </div>
            );
        } else if (selectedType === 9) {
            return (
                <div>
                    <tr className="row">
                        {displaydev.map((dev_item, index) => (
                            <td key={index} className="cellstyle" style={{
                                fontSize: "16px", overflow: "hidden", color: hoveredCell === index ? "#f7f4ef" : "#f7f4ef", backgroundColor: hoveredCell === index ? "#0009df" : cell_color(dev_item.alive)
                            }} onMouseEnter={() => handleCellEnter(index)} onMouseLeave={handleCellLeave}>
                                <table>
                                    <tr style={{ height: "85px" }} >    {dev_item.label}: {dev_item.deviceName} </tr>

                                    <tr>
                                        <div style={{ fontSize: "18px", overflow: "hidden", fontWeight: "bold", color: dev_item.logic === 1 ? hoveredCell === index ? "#f5f0e9" : "red" : hoveredCell === index ? "#f5f0e9" : "green" }} >
                                            <div className="statusstyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                昨晚檢測數: {dev_item.logic}
                                            </div>
                                        </div>
                                    </tr>
                                </table>
                            </td>
                        ))}
                    </tr>
                </div>  
            );
        } else if (selectedType === 10) {
            return (
                <div>
                    <tr className="row">
                        {displaydev.map((dev_item, index) => (
                            <td key={index} className="irrcellstyle" style={{
                                fontSize: "16px", overflow: "hidden", color: hoveredCell === index ? "#f7f4ef" : "#f7f4ef", backgroundColor: hoveredCell === index ? "#0009df" : cell_color(dev_item.alive)
                            }} onMouseEnter={() => handleCellEnter(index)} onMouseLeave={handleCellLeave}>
                                <table>
                                    <tr style={{ marginTop: "auto", textAlign: "center", height: "52px" }} >    {dev_item.label} </tr>
                                    <tr className="irrtimestyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", height: "3px", color: "ffdd0f" }} >    {dev_item.model} </tr>
                                    <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />

                                    <tr>
                                        <div style={{ fontSize: "18px", overflow: "hidden", fontWeight: "bold", color: dev_item.logic === 1 ? hoveredCell === index ? "#f5f0e9" : "red" : hoveredCell === index ? "#f5f0e9" : "green" }} >
                                            <td style={{paddingRight: "20px"}}> <img src={ dev_item.serialNo === "ON" ? Irrigation : IrrigationOff } alt="irrigationStatus" width="40" /> </td>
                                            <td className="irrstyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", color: "#f5f0e9", backgroundColor: dev_item.logic === 1 ? "red" : "#006ec8" }} >
                                                {dev_item.status}
                                            </td>
                                        </div>
                                    </tr>
                                </table>
                            </td>
                        ))}
                    </tr>

                    {/*<tr className="row">
                        {displaydev.map((dev_item, index) => (
                            <td key={index} className="cellstyle" style={{
                                fontSize: "16px", overflow: "hidden", color: hoveredCell === index ? "#f7f4ef" : "#f7f4ef", backgroundColor: hoveredCell === index ? "#0009df" : cell_color(dev_item.alive)
                            }} onMouseEnter={() => handleCellEnter(index)} onMouseLeave={handleCellLeave}>
                                <table>
                                    <tr style={{ height: "85px" }} >    {dev_item.label}: 控制器 </tr>

                                    <tr>
                                        <div style={{ fontSize: "18px", overflow: "hidden", fontWeight: "bold", color: dev_item.logic === 1 ? hoveredCell === index ? "#f5f0e9" : "red" : hoveredCell === index ? "#f5f0e9" : "green" }} >
                                            <div className="statusstyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", color: "#f5f0e9", backgroundColor: dev_item.logic === 1 ? "red" : "#006ec8" }} >
                                                關
                                            </div>
                                        </div>
                                    </tr>
                                </table>
                            </td>
                        ))}
                    </tr>*/}
                </div>
            );
        } else {
            return (
                <div>
                    <tr className="row">
                        {displaydev.map((dev_item, index) => (
                            <td key={index} className="cellstyle" style={{
                                fontSize: "16px", overflow: "hidden", color: hoveredCell === index ? "#f7f4ef" : "#f7f4ef", backgroundColor: hoveredCell === index ? "#0009df" : cell_color(dev_item.alive)
                            }} onMouseEnter={() => handleCellEnter(index)} onMouseLeave={handleCellLeave}>
                                <table>
                                    <tr style={{ height: "85px" }} >    {dev_item.label}: {dev_item.deviceName} </tr>
                                
                                    <tr>
                                <div style={{ fontSize: "18px", overflow: "hidden", fontWeight: "bold", color: dev_item.logic === 1 ? hoveredCell === index ? "#f5f0e9" : "red" : hoveredCell === index ? "#f5f0e9" : "green" }} >
                                    <div className="statusstyle" style={{ marginTop: "auto", textAlign: "center", fontWeight: "bold", color: "#f5f0e9", backgroundColor: dev_item.logic === 1 ? "red" : "#006ec8" }} >
                                        {dev_item.status}
                                    </div>
                                        </div>
                                    </tr>
                                </table>
                            </td>
                        ))}
                    </tr>
                </div>
            );
        }
    };

    /*function DTitle() {
        switch (selectedType) {
            case 1:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  道路管理</tr>
                </div>
                break;
            case 2:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  門口監察</tr>
                </div>
                break;
            case 3:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  後巷監察</tr>
                </div>
                break;
            case 4:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  水浸監察</tr>
                </div>
                break;
            case 6:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  垃圾/回收桶容量監察</tr>
                </div>
                break;
            case 9:
                <div>
                    <tr className="button2style" style={{ width: "1250px", marginTop: "10px", fontSize: "14px", color: "#f7f4ef", backgroundColor: "#878787" }}>  街市鼠蹤夜間監察</tr>
                </div>
                break;
            default:
                break;

        }
    };*/


    const ctext = (p) => {
        console.log(p);
        switch (p) {
            case 1:
                return "#f7f4ef";
                
            case 2:
                return "#f7f4ef";
                
            case 3:
                return "#f7f4ef";
                
            case 4:
                return "#f7f4ef";
                
            default:
                break;
        }
    };

    const cbackground = (p) => {
        console.log(p);
        switch (p) {
            case 1:
                return "#7f7f7f";

            case 2:
                return "#c97500";

            case 3:
                return "#c800c8";

            case 4:
                return "#42a5f5";

            default:
                break;
        }
    };

    function NList() {
        return (
            <div>
                {Array.isArray(tArray.current) &&
                    tArray.current.map((product, p) => (
                        <tr className="row" key={product.index}>
                            <td class="notice-cell" style={{ fontSize: "16px", overflow: "hidden", fontWeight: "bold", color: ctext(product.DataType), backgroundColor: cbackground(product.DataType) }}>
                                {product.Name},{product.Label},{product.Timestamp}
                                {product.Status}
                            </td>
                            <td class="delete-button">
                                <img src={redTick} alt="redtick" width="30px" onClick={() => handleDelete(product)} />

                            </td>
                        </tr>
                    ))
                }
            </div>
        )
    };


    //==================================================================================================================================================
    //==================================================================================================================================================
    //==================================================================================================================================================
    return (
        <div className="containerstyle">
            <table>
                <td >
                    <div >
                        <table style={{ verticalAlign: "top" }} >
                            <tr className="row">
                                <td style={{ verticalAlign: "top", width: "572px"}}>
                                    <table style={{ verticalAlign: "top" }} >
                                        <tr>
                                            <div className="floorpin" >
                                            <FloorplanImage
                                                src={groundFloor} 
                                            />
                                                <ImageWithPins pins={pins_g} />
                                            </div>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ verticalAlign: "top", width: "840px" }}>
                                    <table style={{ verticalAlign: "top" }} >
                                        <tr className="row">
                                            <td className="large-cellstyle" >
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><CarIcon color="primary" /> 車路阻塞監察</div>
                                                <hr style={{ height: "15px", visibility: "hidden", marginTop: "0px",marginBottom: "0px" }} />
                                                    <div style={{ color: "#f7f4ef", fontSize: "26px", overflow: "hidden", fontWeight: "bold", textAlign: "center" }}>
                                                    <div style={{ paddingLeft: "20px" }}><img src={parking} alt="parking" width="110" /></div>
                                                    <hr style={{ height: "3px", visibility: "hidden", marginTop: "0px", marginBottom: "0px" }} />
                                                    <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, color: "#f5f0e9", backgroundColor: carStatus.current === 0 ? "#006ec8" : "red" }} >
                                                        {carStatus.current === 0 ? "暢通" : "部分阻塞"}
                                                    </div>
                                                </div>

                                            </td>
                                            <td className="large-cellstyle" >
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><CarIcon color="primary" /> 殘疾人士專用車位</div>
                                                <hr style={{ height: "2px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ color: "#f7f4ef", fontSize: "26px", overflow: "hidden", fontWeight: "bold", textAlign: "center" }}>
                                                    <div style={{ paddingLeft: "20px" }}><img src={disableParking} alt="disableParking" width="110" /></div>
                                                    <hr style={{ height: "4px", visibility: "hidden", marginTop: "0px", marginBottom: "0px" }} />
                                                    <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                        {3 - disCarStatus.current} 個可用車位
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><DoorIcon color="primary" />門口監察</div>
                                                <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ textAlign: "center" }}> <img src={dooropen464} alt="opendoor" width="60" /> </div>
                                          
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: doorStatus.current === 0 ? "#006ec8" : "red" }} >
                                                    {doorStatus.current === 0 ? "關閉" : "部分已開"}
                                                </div>
                                        
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><DeleteOutlineIcon color="primary" /> 電車充電監察</div>
                                                <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ overflow: "hidden", fontWeight: "bold", textAlign: "center" }}>
                                                    <img src={CarCharger} alt="carcharger" width="60" />
                                                </div>
                                                <div className="lgstatusstyle" style={{ textAlign: "center", fontSize: LargeCellText, overflow: "hidden", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#006ec8" }}>正常</div>

                                            </td>
                                        </tr>

                                        {// ========================= Row split} ===================
                                        }
                                        <tr className="row">
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><WaterDropIcon color="primary" /> 水浸監察</div>
                                                <hr style={{ height: "2px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ textAlign: "center" }}> <img src={waterdrop} alt="waterdrop" width="37" /> </div>
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: leakStatus.current === 0 ? "#006ec8" : "red" }} >
                                                    {leakStatus.current === 0 ? "正常" : "漏水"}
                                                </div>
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><OccupiedIcon color="primary" /> 後巷監察</div>
                                                <hr style={{ height: "2px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ textAlign: "center" }}> <img src={ppeople} alt="ppeople" width="50" /> </div>
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: corridorStatus.current === 0 ? "#006ec8" : "red" }} >
                                                    {corridorStatus.current === 0 ? "正常" : "部份有人"}
                                                </div>
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><ShoppingCartIcon color="primary" />風喉頂夜間監察</div>
                                                <div style={{ textAlign: "center" }}> <img src={Trolley} alt="trolley" width="74" /> </div>
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "25px", fontWeight: "bold", color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                    昨晚平均數: {ratStatus.current} 次
                                                </div>
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><GrassIcon color="primary" /> 自動灌溉系統監察</div>

                                            </td>
                                        </tr>

                                        <tr className="row">
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><DeleteOutlineIcon color="primary" /> 垃圾/回收桶監察</div>
                                                <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ overflow: "hidden", fontWeight: "bold", textAlign: "center" }}>
                                                    <img src={rubbishbin} alt="rubbishbin" width="55" />
                                                </div>
                                                <div className="lgstatusstyle" style={{ textAlign: "center", fontSize: LargeCellText, overflow: "hidden", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#006ec8" }}>正常</div>

                                            </td>

                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><WcIcon color="primary" /> 暢通易達洗手間監察</div>
                                                <hr style={{ height: "2px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ textAlign: "center" }}> <img src={FallDetect} alt="ppeople" width="62" /> </div>
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: fallStatus.current.logic === 0 ? "#006ec8" : "red" }} >
                                                    {fallStatus.current.status}
                                                </div>

                                            </td>

                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><GrassIcon color="primary" /> 自動灌溉系統監察</div>
                                                <hr style={{ height: "0px", visibility: "hidden", marginBottom: "0px" }} />
                                                <div style={{ textAlign: "center" }}> <img src={Irrigation} alt="irrigation" width="55" /> </div>
                                                <div className="lgstatusstyle" style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: LargeCellText, fontWeight: "bold", color: "#f5f0e9", backgroundColor: "#006ec8" }} >
                                                    {irrStatus.current === 0 ? "正常" : "部份乾燥"}
                                                </div>
                                            </td>
                                            <td className="large-cellstyle">
                                                <div style={{ color: "#f7f4ef", backgroundColor: "#676767" }} ><GrassIcon color="primary" /> 自動灌溉系統監察</div>

                                            </td>
                                        </tr>





                                    </table>
                                </td>
                                <td style={{ verticalAlign: "top", width: "475px", maxHeight: "590px", overflowY: "auto" }}>
                                    <table className="notice-style" style={{ verticalAlign: "top" }} >
                                        <div style={{ fontSize: "24px", fontWeight: "bold", color: "f7f4ef" }}>
                                            狀態通知
                                        </div>

                                        <NList />

                                    </table>
                                </td>
                            </tr>
                        </table>    
                    </div>
                    <div >
                        <table>
                            <tr>
                                <td style={{ verticalAlign: "top", width: "8%", height: "13.4rem" }}>
                                    <div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", fontWeight: "bold", color: "#f5f1eb", backgroundColor: "#4f4f4f" }} >
                                            物聯網應用
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 1 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 1 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(1)}>
                                            道路管理
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 2 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 2 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(2)}>
                                            門口監察
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 3 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 3 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(3)}>
                                            後巷監察
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 4 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 4 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(4)}>
                                            水浸監察
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 6 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 6 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(6)}>
                                            垃圾/回收桶容量監察
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 9 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 9 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(9)}>
                                            風喉頂夜間監察
                                        </div>
                                        <div className="buttonstyle" style={{ fontSize: "15px", color: selectedType === 10 ? "#202020" : "#f5f1eb", backgroundColor: selectedType === 10 ? "#BfBfBf" : "#4f4f4f" }} onClick={() => handleClick(10)}>
                                            自動灌溉系統監察
                                        </div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>
                       
                                        
                                            <DList />
                                        
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );
}
